import { createSelector } from 'reselect';
import {
  taxYearsWithAllOptionsSelector,
  taxYearOrAllSelector,
  reportingCurrencyCodeSelector,
} from '../../../shared/store/selectors';

import { TAX_CURRENCY, allCountryTaxes } from '../constants';

export const selectPeriodFrom = createSelector(
  ({ balanceSheetManagement }) => balanceSheetManagement.aggregation.periodFrom,
  ({ shared }) => shared.yearStartPeriod,
  (fromPeriod, yearStartPeriod) => fromPeriod

    || {
      name: yearStartPeriod.periodName,
      taxYear: yearStartPeriod.taxYear,
      value: yearStartPeriod.periodName,
    }
);

export const selectPeriodTo = createSelector(
  ({ balanceSheetManagement }) => balanceSheetManagement.aggregation.periodTo,
  ({ shared }) => shared.currentPeriod,
  (toPeriod, currentPeriod) => toPeriod
    || {
      name: currentPeriod.name,
      taxYear: currentPeriod.taxYear,
      value: currentPeriod.name,
    }
);

export const selectSlGroupTypes = createSelector(
  ({ balanceSheetManagement }) => balanceSheetManagement.aggregation.slGroupTypes,
  slGroupTypes => slGroupTypes.map(({ name, value }) => ({
    label: name,
    value,
  }))
);

export const selectSlGroupType = ({ balanceSheetManagement }) => balanceSheetManagement.aggregation.slGroupType;

export const selectSlGroupItems = createSelector(
  ({ balanceSheetManagement }) => balanceSheetManagement.aggregation.slGroupItems,
  slGroupItems => slGroupItems.map(({ groupItem, groupItemDescription }) => ({
    label: groupItemDescription ? groupItemDescription : groupItem,
    value: groupItem,
  }))
);

export const selectSlGroupItem = ({ balanceSheetManagement }) => balanceSheetManagement.aggregation.slGroupItem;

export const selectCountryTaxTypes = createSelector(
  ({ balanceSheetManagement }) => balanceSheetManagement.aggregation.countryTaxTypes,
  countryTaxTypes => [allCountryTaxes].concat(countryTaxTypes.map(({ countryTaxType, description }) => ({
    label: description,
    value: countryTaxType,
  })))
);

export const selectCountryTaxType = ({ balanceSheetManagement }) => balanceSheetManagement.aggregation.countryTaxType;

export const selectIsFetchingSlGroups = ({ balanceSheetManagement }) =>
  balanceSheetManagement.aggregation.isFetchingSlGroupTypes
  || balanceSheetManagement.aggregation.isFetchingSlGroupItems;

export const selectIsFetchingCountryTaxTypes = ({ balanceSheetManagement }) =>
  balanceSheetManagement.aggregation.isFetchingCountryTaxTypes;

export const selectCurrencyCode = ({ balanceSheetManagement }) => balanceSheetManagement.aggregation.currencyCode;

export const selectBookTypes = ({ balanceSheetManagement }) => balanceSheetManagement.aggregation.bookTypes;
export const selectBookType = ({ balanceSheetManagement }) => {
  const { bookType } = balanceSheetManagement.aggregation;

  return bookType;
};

export const selectTaxYears = taxYearsWithAllOptionsSelector;
export const selectTaxYear = taxYearOrAllSelector;

export const currencyToDisplaySelector = createSelector(
  reportingCurrencyCodeSelector,
  selectCurrencyCode,
  (reportingCurrency, taxCurrency) => reportingCurrency === TAX_CURRENCY ? taxCurrency : reportingCurrency
);

export const reportingCurrencyCodesForGroupSelector = state =>
  state.balanceSheetManagement.aggregation.reportingCurrencyCodes;

export const extraReportingCurrencyCodesForGroupSelector = extraCurrencies => createSelector(
  reportingCurrencyCodesForGroupSelector,
  currencyCodes => {
    const mappedExtraCurrencies = extraCurrencies.map(currency => ({ value: currency }));
    const newCurrencyCodes = [
      ...currencyCodes.slice(0, 1),
      ...mappedExtraCurrencies,
      ...currencyCodes.slice(1),
    ];
    return newCurrencyCodes.map(({ value }) => ({ value, label: value }));
  }
);
